/**
 * shell/topbar.tsx — compact mobile-only bar with the drawer trigger + brand.
 * (Desktop/tablet dock the full sidebar, so no topbar there.)
 */
import React from 'react';
import { View, Pressable } from 'react-native';
import { LightColors as C, Radii as R, FontSize as FS, FontWeight as FW, Shadows as SH } from '../theme/theme';
import { Txt } from '../components/ui';
import Icon from '../components/icon';
import { useApp } from '../context/appContext';

const Topbar: React.FC<{ onMenu: () => void }> = ({ onMenu }) => {
  const { meta } = useApp();
  return (
    <View
      style={{
        height: 52,
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        paddingHorizontal: 16,
        backgroundColor: C.card,
        borderBottomWidth: 1,
        borderBottomColor: C.line,
      }}
    >
      <Pressable onPress={onMenu} accessibilityLabel="Open menu" hitSlop={8}>
        <Icon name="menu" size={22} color={C.ink} />
      </Pressable>
      <View
        style={{
          width: 26,
          height: 26,
          borderRadius: 6,
          backgroundColor: C.accent,
          alignItems: 'center',
          justifyContent: 'center',
          ...(SH.sm as object),
        }}
      >
        <Txt size={13} weight={FW.bold} color="#FFFFFF">
          {meta.brand}
        </Txt>
      </View>
      <Txt size={FS.md} weight={FW.semibold} color={C.ink}>
        SK Upsell
      </Txt>
    </View>
  );
};

export default Topbar;
